import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

/**
 * i18n Configuration with HTTP Backend
 *
 * This configuration enables lazy-loading of translation files:
 * - Only the current language is loaded on initial page load
 * - Switching languages loads the new language on-demand
 * - Reduces initial bundle size by ~50% (from ~14KB to ~7KB per language)
 *
 * Translation files are served from /public/locales/
 */

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Backend configuration for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}.json',
      // Add cache busting to ensure users get latest translations
      queryStringParams: { v: '1.0.0' }
    },

    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    // Reduce console logs in production
    debug: false,

    // React-specific options
    react: {
      useSuspense: true,
    },
  });

export default i18n;